import { feedbackcard, YesObject } from '@yes.technology/react-toolkit'
import { useAuth } from 'authentication/shared/hooks'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18n-lite'
import {
  ExecutionState,
  OutputTaskHandler
} from 'workflow/shared/types/workflow.type'
import fetchYesObjects from 'yesObject/shared/api/fetchYesObjects'

export const useRedirectInteraction = () => {
  const { token: authToken } = useAuth()

  const { t, language } = useTranslation()

  const redirectToInteractionURL = useCallback(
    async (task: YesObject) => {
      const response = await fetchYesObjects({
        filterBody: {
          objectclass: globalThis.taskObjectclassUuid,
          query: {
            $and: [{ 'uuid.des': { $eq: task.uuid } }]
          },
          orderby: [],
          skip_relations: false,
          pagination: {
            offset: 0,
            limit: 1
          }
        },
        showLoading: false
      })

      const token = response.objects?.[0]?.workflow?.[0] as YesObject

      const rawExecutionState = (token?.execution_state as string) || 'null'

      let executionState: ExecutionState | null = null

      try {
        executionState = JSON.parse(rawExecutionState) as ExecutionState
      } catch (error) {
        console.error(
          'Failed to parse execution_state:',
          rawExecutionState,
          error
        )
        executionState = null
      }

      const nodes = executionState?.nodes || []

      const outputTaskNode = nodes.find(({ uuid }) => uuid === task.uuid)
      const { nodemodel_uuid: outputNodemodelUuid } = outputTaskNode || {}

      const nodeModels = executionState?.flow_elementmodels?.nodemodels || []

      const outputNodeModel = nodeModels.find(
        ({ uuid }) => uuid === outputNodemodelUuid
      )

      const outputActionHandler = outputNodeModel?.handler as OutputTaskHandler
      const interactionModelUuid = outputActionHandler?.interactionmodel_uuid
      const targetContainerVariable =
        outputActionHandler?.target_container_variable

      const queryParams = new URLSearchParams({
        token: authToken,
        lang: language,
        uuid_workflow: token?.uuid,
        processValuesVariable: targetContainerVariable || '',
        hideInteractionContainer: 'true'
      })

      const queryString = queryParams.toString()
      const redirectURL =
        `${globalThis.waWorkflowengineUrl}interaction/${token?.uuid}` +
        `/${interactionModelUuid}?${queryString}`

      if (token) {
        window.open(redirectURL, '_blank')
        return
      }

      feedbackcard(t('generic-error'), { type: 'error' })
      console.error('Missing binded Token to this Task')
    },
    [authToken, language, t]
  )

  return { redirectToInteractionURL }
}
